


















import { defineComponent, PropType, toRefs } from '@vue/composition-api'
import { UserInfoState } from '@/layout/types'
import { provideUserInfoState } from '@/use/biz/use-userInfo'
import { shellConfig } from './shell-config'
import Cookie from 'js-cookie'
import { HOSTS } from '@/constants/environment'

export default defineComponent({
  name: 'Framework',
  props: {
    loading: Boolean,
    content: String,
    userInfoState: {
      required: true,
      type: Object as PropType<UserInfoState>,
    },
  },
  setup(props) {
    const refProps = toRefs(props)

    provideUserInfoState(refProps.userInfoState)

    const isSandboxShow = Cookie.get('sandbox_env') === '1'

    // 客户反馈回退旧菜单特殊处理，菜单栏三期后删除
    return {
      currentLayout: shellConfig.layout,
      isSandboxShow,
      crmUrl: HOSTS.CRM_HOST,
    }
  },
})
